import React from "react";

export const LoginHeader = () => {
    return (
        <div className="text-center mb-8">
            <div className="flex items-center justify-center mb-4">
                <div className="bg-blue-600 p-3 rounded-full shadow-lg">
                    <i className="fas fa-tasks text-white text-2xl"></i>
                </div>
            </div>
            <h1 className="text-4xl font-bold text-gray-800 mb-2">TodoList Pro</h1>
            <p className="text-gray-600">Organiza tu día de manera eficiente</p>
        </div>
    );
};